/** Flat string tables for shift staff UI (no i18next). */
export const SHIFT_LOCALES = {
  'zh-Hant': {
    'lang.zh': '繁中',
    'lang.en': 'EN',

    'common.back': '返回',
    'common.logout': '登出',
    'common.loading': '載入中…',
    'common.save': '儲存',
    'common.cancel': '取消',
    'common.today': '今日',

    'shift.early': '早班',
    'shift.late': '晚班',
    'shift.night': '夜班',
    'shift.maintenance': '維護班',

    'role.staff': '員工',
    'role.supervisor': '小主管',
    'role.ownerView': '老闆檢視',
    'role.ownerPill': 'Nana',

    'login.title': '齊文藝室',
    'login.sub': '班別管理系統',
    'login.codeLabel': '員工代號',
    'login.placeholder': '請輸入 4–6 碼代號',
    'login.submit': '登入',
    'login.submitting': '登入中…',
    'login.errCode': '請輸入 4–6 碼員工代號',
    'login.errBad': '員工代號錯誤或帳號已停用',
    'login.errFail': '登入失敗，請稍後再試',

    'layout.docTitle': '班別管理｜齊文藝室',

    'chrome.noShift': '未選班別',
    'chrome.changeShift': '改班',
    'chrome.themeLight': '亮色',
    'chrome.themeDark': '暗色',
    'chrome.themeTitle': '切換亮／暗色',
    'chrome.extraLeft': '額外 {{n}}',
    'chrome.progressHint': '各班進度請至「進度」分頁',
    'chrome.shiftUpdateFail': '班別更新失敗',
    'chrome.viewMode': '檢視：{{label}} ▾',
    'chrome.supervisorSuffix': ' · 主管',

    'home.tab.tasks': '待辦',
    'home.tab.extra': '額外',
    'home.tab.tree': '任務',
    'home.tab.announce': '公告',
    'home.tab.progress': '進度',
    'home.tab.anomaly': '回報',
    'home.tab.inventory': '點貨',
    'home.tab.order': '叫貨',
    'home.tab.sales': '銷售',
    'home.tab.revenue': '營收',
    'home.tab.schedule': '排班',
    'home.tab.month': '月班',
    'home.navAria': '主分頁',
    'home.doneMeta': '{{done}}/{{total}} 完成',
    'home.loadInv': '載入點貨…',
    'home.availBanner': '{{month}} 排班填寫',
    'home.availDeadline': ' · 截止 {{at}}',
    'home.availMissing': ' · 還缺 {{n}} 天',
    'home.availGo': '去填排班',
    'home.todayNote': '今日：{{note}}',

    'pick.title': '選擇今日班別',
    'pick.hint': '請確認你今天要執行的班別後再開始',
    'pick.confirm': '確認班別',
    'pick.redirect': '導向中…',
    'pick.saveFail': '儲存班別失敗，請重試',

    'anomaly.untitled': '（無標題）',
    'anomaly.statusPending': '待處理',
    'anomaly.statusAcked': '已受理',
    'anomaly.statusResolved': '已結案',
    'anomaly.ownerReply': '老闆回覆：{{note}}',
    'anomaly.notePlaceholder': '回覆／處理備註…',
    'anomaly.ack': '受理',
    'anomaly.resolve': '結案並回覆',
    'anomaly.loadFail': '載入回報失敗',
    'anomaly.updateFail': '更新失敗',
    'anomaly.empty': '今日尚無回報',
    'anomaly.teamToday': '今日團隊回報',
    'anomaly.add': '＋ 新增回報',
    'anomaly.collapseForm': '收合表單',
    'anomaly.redirect': '導向回報…',

    'avail.title': '排班',
    'month.title': '月班表',
    'month.published': '已發布',
    'month.unpublished': '尚未發布',
    'month.empty': '本月班表尚未發布',
    'month.mine': '我的班',
    'month.all': '所有人',
    'month.prev': '← 上個月',
    'month.next': '下個月 →',
    'month.sheet': '總表',
    'month.dayList': '日列表',
  },
  en: {
    'lang.zh': '繁中',
    'lang.en': 'EN',

    'common.back': 'Back',
    'common.logout': 'Log out',
    'common.loading': 'Loading…',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.today': 'Today',

    'shift.early': 'Early',
    'shift.late': 'Late',
    'shift.night': 'Night',
    'shift.maintenance': 'Maintenance',

    'role.staff': 'Staff',
    'role.supervisor': 'Supervisor',
    'role.ownerView': 'Owner view',
    'role.ownerPill': 'Nana',

    'login.title': 'Chiwen Studio',
    'login.sub': 'Shift management',
    'login.codeLabel': 'Staff code',
    'login.placeholder': 'Enter 4–6 digit code',
    'login.submit': 'Sign in',
    'login.submitting': 'Signing in…',
    'login.errCode': 'Enter a 4–6 digit staff code',
    'login.errBad': 'Invalid code or account disabled',
    'login.errFail': 'Sign-in failed. Try again later',

    'layout.docTitle': 'Shifts | Chiwen Studio',

    'chrome.noShift': 'No shift',
    'chrome.changeShift': 'Change',
    'chrome.themeLight': 'Light',
    'chrome.themeDark': 'Dark',
    'chrome.themeTitle': 'Toggle light / dark',
    'chrome.extraLeft': 'Extra {{n}}',
    'chrome.progressHint': 'See Progress tab for each shift',
    'chrome.shiftUpdateFail': 'Failed to update shift',
    'chrome.viewMode': 'View: {{label}} ▾',
    'chrome.supervisorSuffix': ' · Supervisor',

    'home.tab.tasks': 'Todo',
    'home.tab.extra': 'Extra',
    'home.tab.tree': 'Tasks',
    'home.tab.announce': 'News',
    'home.tab.progress': 'Progress',
    'home.tab.anomaly': 'Reports',
    'home.tab.inventory': 'Stock',
    'home.tab.order': 'Order',
    'home.tab.sales': 'Sales',
    'home.tab.revenue': 'Revenue',
    'home.tab.schedule': 'Avail.',
    'home.tab.month': 'Month',
    'home.navAria': 'Main tabs',
    'home.doneMeta': '{{done}}/{{total}} done',
    'home.loadInv': 'Loading stock…',
    'home.availBanner': '{{month}} availability',
    'home.availDeadline': ' · Due {{at}}',
    'home.availMissing': ' · {{n}} days left',
    'home.availGo': 'Fill now',
    'home.todayNote': 'Today: {{note}}',

    'pick.title': 'Choose today’s shift',
    'pick.hint': 'Confirm which shift you will work today before starting',
    'pick.confirm': 'Confirm shift',
    'pick.redirect': 'Redirecting…',
    'pick.saveFail': 'Could not save shift. Try again',

    'anomaly.untitled': '(Untitled)',
    'anomaly.statusPending': 'Pending',
    'anomaly.statusAcked': 'Acknowledged',
    'anomaly.statusResolved': 'Resolved',
    'anomaly.ownerReply': 'Owner reply: {{note}}',
    'anomaly.notePlaceholder': 'Reply / handling notes…',
    'anomaly.ack': 'Acknowledge',
    'anomaly.resolve': 'Resolve & reply',
    'anomaly.loadFail': 'Failed to load reports',
    'anomaly.updateFail': 'Update failed',
    'anomaly.empty': 'No reports today',
    'anomaly.teamToday': 'Team reports today',
    'anomaly.add': '+ New report',
    'anomaly.collapseForm': 'Hide form',
    'anomaly.redirect': 'Opening reports…',

    'avail.title': 'Availability',
    'month.title': 'Month schedule',
    'month.published': 'Published',
    'month.unpublished': 'Not published',
    'month.empty': 'This month’s schedule is not published yet',
    'month.mine': 'Mine',
    'month.all': 'Everyone',
    'month.prev': '← Prev month',
    'month.next': 'Next month →',
    'month.sheet': 'Sheet',
    'month.dayList': 'Day list',
  },
};
